/**
 * Determines the type of direction.
 */
enum Direction {
    Horizontal = 1,
    Vertical = 2
}

export { Direction };
